// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2FHHu","title":"InfoRow_title__3LWs5"};